import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass rounded-3xl p-10 max-w-md text-center" data-testid="payment-cancel-card">
        <XCircle className="w-12 h-12 text-foreground/50 mx-auto mb-5" />
        <h1 className="font-display font-black text-3xl mb-2">Payment cancelled</h1>
        <p className="text-foreground/60 mb-8">No charge was made. You can try again anytime.</p>
        <Button data-testid="back-to-dashboard-btn" onClick={() => navigate("/dashboard")} className="rounded-full h-12 px-6 bg-gold hover:bg-gold/90 text-black font-semibold">Back to dashboard</Button>
      </motion.div>
    </div>
  );
}
